import { Application } from '@wellesley/openapi'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { appsListSlice } from '../appsListSlice'
import { userSlice } from '@wellesley/user'
import { getEntryAppRoute } from '@wellesley/router'

export const useGetAppLink = () => {
  const { selectActiveGroupName, selectEntryPoint } = appsListSlice.selectors

  const groupname = useSelector(selectActiveGroupName)
  const entryPoint = useSelector(selectEntryPoint)
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)
  const username = currentUser?.username || undefined

  const getLink = useCallback(
    (app: Application) =>
      getEntryAppRoute({
        id: app.id,
        routes: app.manifest.routes,
        username,
        groupname: groupname || undefined,
        entryPoint,
      }),
    [entryPoint, groupname, username],
  )

  return getLink
}
